import { useState, useRef, useEffect } from 'react';
import { llamarClaude, usuarioActual } from './apidoo';
import './Asistente.css';

const BIENVENIDA = {
  role: 'assistant',
  content: '¡Hola! Bienvenido a la Clínica Plaza Coinco. Soy Sofía. ¿En qué puedo ayudarte hoy?',
};

export default function Asistente({ onCerrarSesion }) {
  const [historial, setHistorial]   = useState([BIENVENIDA]);
  const [inputTexto, setInputTexto] = useState('');
  const [procesando, setProcesando] = useState(false);

  const mensajesRef = useRef(null);
  const inputRef    = useRef(null);

  // Auto-scroll al último mensaje
  useEffect(() => {
    const el = mensajesRef.current;
    if (el) el.scrollTop = el.scrollHeight;
  }, [historial, procesando]);

  // Devolver foco al input cuando Sofía termina de responder
  useEffect(() => {
    if (!procesando) inputRef.current?.focus();
  }, [procesando]);

  // Re-scroll cuando aparece/desaparece el teclado virtual (móvil)
  useEffect(() => {
    const vv = window.visualViewport;
    if (!vv) return;
    const onResize = () => {
      const el = mensajesRef.current;
      if (el) el.scrollTop = el.scrollHeight;
    };
    vv.addEventListener('resize', onResize);
    return () => vv.removeEventListener('resize', onResize);
  }, []);

  const enviar = async () => {
    const texto = inputTexto.trim();
    if (!texto || procesando) return;

    setInputTexto('');
    setProcesando(true);

    // Agregar mensaje del usuario al historial visible
    const nuevoHistorial = [...historial, { role: 'user', content: texto }];
    setHistorial(nuevoHistorial);

    try {
      // El backend recibe el historial, ejecuta el loop tool_use con Claude
      // y devuelve solo el texto final de Sofía.
      const respuesta = await llamarClaude(nuevoHistorial);
      setHistorial(prev => [...prev, { role: 'assistant', content: respuesta }]);
    } catch (err) {
      console.error('[Claude]', err);
      setHistorial(prev => [
        ...prev,
        { role: 'assistant', content: 'Lo siento, tuve un problema al conectarme. Por favor intenta nuevamente.' },
      ]);
    }

    setProcesando(false);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      enviar();
    }
  };

  return (
    <div className="chat-wrapper">

      {/* Header */}
      <div className="chat-header">
        <div className="chat-avatar">S</div>
        <div className="chat-header-info">
          <span className="chat-nombre">Sofía</span>
          <span className="chat-subtitulo">Clínica Plaza Coinco</span>
        </div>
        <button
          className="chat-logout-btn"
          onClick={onCerrarSesion}
          title={`Cerrar sesión (${usuarioActual()})`}
        >
          <svg viewBox="0 0 24 24" fill="white" width="18" height="18">
            <path d="M10 9V5l-7 7 7 7v-4.1c5 0 8.5 1.6 11 5.1-1-5-4-10-11-11z"/>
          </svg>
        </button>
      </div>

      {/* Mensajes */}
      <div className="chat-mensajes" ref={mensajesRef}>
        <div className="chat-mensajes-spacer" />
        {historial.map((msg, i) => (
          <div key={i} className={`burbuja-wrapper ${msg.role === 'user' ? 'derecha' : 'izquierda'}`}>
            <div className={`burbuja ${msg.role === 'user' ? 'burbuja-usuario' : 'burbuja-sofia'}`}>
              {msg.content}
            </div>
          </div>
        ))}
        {procesando && (
          <div className="burbuja-wrapper izquierda">
            <div className="burbuja burbuja-sofia burbuja-escribiendo">
              <span /><span /><span />
            </div>
          </div>
        )}
      </div>

      {/* Input */}
      <div className="chat-input-bar">
        <textarea
          ref={inputRef}
          className="chat-input"
          rows={1}
          placeholder="Escribe un mensaje..."
          value={inputTexto}
          onChange={e => setInputTexto(e.target.value)}
          onKeyDown={handleKeyDown}
          disabled={procesando}
        />
        <button
          className="chat-send-btn"
          onMouseDown={e => e.preventDefault()}
          onClick={enviar}
          disabled={procesando || !inputTexto.trim()}
          title="Enviar"
        >
          <svg viewBox="0 0 24 24" fill="white" width="22" height="22">
            <path d="M2 21l21-9L2 3v7l15 2-15 2z"/>
          </svg>
        </button>
      </div>

    </div>
  );
}
